import { render, staticRenderFns } from "./AdminListaInterna.vue?vue&type=template&id=0ad2d6ae&scoped=true&"
import script from "./AdminListaInterna.vue?vue&type=script&lang=js&"
export * from "./AdminListaInterna.vue?vue&type=script&lang=js&"
import style0 from "./AdminListaInterna.vue?vue&type=style&index=0&id=0ad2d6ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad2d6ae",
  null
  
)

export default component.exports